import { QueryKeyFactory } from "./queryKeysFactory";
import useApi from "./useApi";

import { SurveyResult } from "~/typing/sidekickTypes";

export default function useSurveyResults({
  programCatalogItemId,
  locale,
  userId,
  surveyId
}: {
  programCatalogItemId: string;
  locale: string;
  userId: string;
  surveyId: string;
}) {
  const path = `/coach/programs/${programCatalogItemId}/locales/${locale}/users/${userId}/surveys/${surveyId}/surveyresults`;
  const { data, isError, isLoading, invalidate } = useApi<{
    items: SurveyResult[];
  }>({
    path,
    queryKey: QueryKeyFactory.users.surveyResults(userId, surveyId)
  });
  return {
    surveyResults: data?.items,
    isError,
    isLoading,
    invalidate
  };
}
